import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {NameId} from '@drl/core/models';

@Injectable()
export class FilterModelAdapterService implements IAdapter<NameId> {
  adaptToModel(resp: any): NameId {
    const condition: NameId = new NameId();
    if (resp) {
      condition.id = resp.id;
      condition.name = resp.Name;
    }
    return condition;
  }
  adaptFromModel(data: NameId): any {
    return data;
  }
}
